<template>
  <transition :name="direction === 'right' ? 'slide-left' : direction === 'left' ? 'slide-right' : direction === 'bottom' ? 'slide-bottom' : null ">
    <div
      class="mw-100 fixed cl-accent bg-cl-primary async-container"
      :class="{ 'grow-layer': layerIndex, 'left-sidebar': direction === 'left', 'right-sidebar': direction === 'right', 'bottom-sidebar': direction === 'bottom' }"
      data-testid="sidebar"
      v-if="isOpen"
    >
      <component :is="component" @close="$emit('close')" @reload="getComponent" />
    </div>
  </transition>
</template>

<script>
import LoadingSpinner from 'theme/components/theme/blocks/AsyncSidebar/LoadingSpinner.vue'
import LoadingError from 'theme/components/theme/blocks/AsyncSidebar/LoadingError.vue'

export default {
  props: {
    asyncComponent: {
      type: Function,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    layerIndex: {
      type: Boolean,
      required: false
    },
    /** "right" or "left"  */
    direction: {
      type: String,
      default: 'right'
    }
  },
  data () {
    return {
      component: null
    }
  },
  created () {
    this.getComponent()
  },
  methods: {
    getComponent () {
      this.component = () => ({
        component: this.asyncComponent(),
        loading: LoadingSpinner,
        error: LoadingError,
        timeout: 3000
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~theme/css/animations/transitions";

  .grow-layer {
    z-index: 8 !important;
  }

  .slide-left-enter-active,
  .slide-left-leave-active,
  .slide-right-enter-active,
  .slide-right-leave-active,
  .slide-bottom-enter-active,
  .slide-bottom-leave-active{
    transition: transform .25s;
  }

  .slide-left-enter,
  .slide-left-leave-to {
    transform: translateX(100%);
  }

  .slide-right-enter,
  .slide-right-leave-to {
    transform: translateX(-100%);
  }

  .slide-bottom-enter,
  .slide-bottom-leave-to {
      transform: translateY(100%);
  }
  .bottom-sidebar {
      top: 0;
      right: 0;
      z-index: 4;
      height: 100%;
      width: 100%;
      min-width: 320px;
      overflow-y: auto;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
  }
  .right-sidebar {
    top: 0;
    right: 0;
    z-index: 6;
    height: 100%;
    width: 800px;
    min-width: 320px;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .left-sidebar{
    height: -webkit-fill-available;
    width: 350px;
    top: 0;
    left: 0;
    overflow: hidden;
    overflow-y: auto;
    z-index: 4;
    -webkit-overflow-scrolling: touch;
    @media (max-width: 768px) {
      width: -webkit-fill-available;
    }
  }

  .close {
    i {
      opacity: 0.6;
    }
    &:hover,
    &:focus {
      i {
        opacity: 1;
      }
    }
  }
</style>
